import { render } from "./psd_image_space.vue?vue&type=template&id=f4683cac"
import script from "./psd_image_space.vue?vue&type=script&lang=js"
export * from "./psd_image_space.vue?vue&type=script&lang=js"

import "./psd_image_space.vue?vue&type=style&index=0&id=f4683cac&lang=css"

import exportComponent from "E:\\devops.aliyun\\liangting\\liangting_business_web\\seller.web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__